export default __webpack_public_path__ + "static/media/fat-close.7d7bf145.svg";